@if (!job.referredToDipl) {
    <span [ngbTooltip]="tt" container="body">
        @if (!job.dateCompleted) {
            @if (job.slaBreach | str2Date | amIsBefore: (null | str2Date)) {
                <div class="badge bg-danger">{{ job.slaBreach | str2Date | amTimeAgo }}</div>
            } @else {
                @if (job.slaBreach | str2Date | amIsAfter: (null | str2Date | amAdd: 1 : 'week')) {
                    <div class="badge bg-success">{{ job.slaBreach | str2Date | amTimeAgo }}</div>
                } @else {
                    <div class="badge bg-warning text-dark">{{ job.slaBreach | str2Date | amTimeAgo }}</div>
                }
            }
        } @else {
            @if ((job.slaBreach | str2Date) >= (job.dateCompleted | str2Date)) {
                <div class="badge bg-success">
                    <i class="fa fa-check"></i>
                    {{ job.slaBreach | str2Date | amDifference: (job.dateCompleted | str2Date) : 'days' }} days
                </div>
            } @else {
                <div class="badge bg-danger">
                    <i class="fa fa-times"></i>
                    {{ job.slaBreach | str2Date | amDifference: (job.dateCompleted | str2Date) : 'days' }} days
                </div>
            }
        }
    </span>
}
<ng-template #tt>{{ job.slaBreach | str2Date | date: 'short' }}</ng-template>
